import { makeStyles } from '@material-ui/styles';
import { darkBlue, gainsboro, white } from '../../../constants/Colors';

export default makeStyles(() => ({
    pageContainer: {
        width: 1000,
        margin: '0 auto',
        backgroundColor: '#f6f6f6',
    },
    selectTemplateContainer: {
        padding: '10px 20px',
        boxSizing: 'border-box',
        borderBottom: `1px solid ${gainsboro}`,
        flexShrink: '0',
        marginTop: '20px',
    },
    textEditorContainer: {
        padding: '10px 20px ',
        boxSizing: 'border-box',
        borderBottom: `1px solid ${gainsboro}`,
        height: ({ isLinkedinContactForm }) => (isLinkedinContactForm ? 'calc(100% - 240px)' : 'calc(100% - 325px)'),
    },
    emailSubjectAndBodyInput: {
        height: ({ emailSubjectAndBodyInputHeight }) => (emailSubjectAndBodyInputHeight
            ? `${emailSubjectAndBodyInputHeight}px`
            : '100%'
        ),
    },
    selectTemplateLabel: {
        fontSize: '15px',
        marginBottom: '5px',
    },
    selectTemplateSelect: {
        backgroundColor: white,
    },
    textAreaContainer: {
        marginTop: 10,
        margin: '10px 40px 0 21px',
    },
    textArea: {
        width: '100%',
        border: 'none',
        padding: '10px',
        '&:focus-visible': {
            outline: 'none',
        },
        font: 'inherit',
        resize: 'none',
    },
    actionsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 21px',
        height: '36px',
        paddingTop: '40px',
    },
    labelContainer: {
        padding: '21px',
    },
    headerContainer: {
        position: 'relative',
        height: '40px',
        fontSize: '17px',
        padding: '8px 20px',
        backgroundColor: darkBlue,
        color: white,
        boxSizing: 'border-box',
        flexShrink: '0',
    },
    closeButtonContainer: {
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: 1,
        '& svg': {
            color: white,
        },
    },
    closeButton: {
        padding: '8px',
    },
}));
